import { useSelector } from "react-redux";
import { allNotificationsSelector } from "../../redux/notifications/selectors";
import Notification from "./Notification";
import "./styles.scss";

const NotificationsToaster = () => {
    const notifications = useSelector(allNotificationsSelector);
    return (
        <div className="toast-container">
            {notifications?.map(Notification)}
        </div>
    );
};

export default NotificationsToaster;